import floridayI18n from '@floriday/floriday-ui/i18n'
import { Modal, UserMenuRadioItem } from '@floriday/floriday-ui'
import ReactCountryFlag from 'react-country-flag'
import { Box, MenuList, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type LanguageSelectorDialogProps = {
  open: boolean
  onClose: () => void
}

const LanguageMenuLabel = ({
  countryCode,
  label,
}: {
  countryCode: 'nl' | 'gb'
  label: string
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <ReactCountryFlag
      countryCode={countryCode}
      svg
      style={{ width: '1em', height: '1em' }}
    />
    <Typography component='span'>{label}</Typography>
  </Box>
)

export const LanguageSelectorDialog = ({
  open,
  onClose,
}: LanguageSelectorDialogProps) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.resolvedLanguage === 'en' ? 'en' : 'nl'

  const handleLanguageChange = async (language: 'nl' | 'en') => {
    await i18n.changeLanguage(language)
    await floridayI18n.changeLanguage(language)
    onClose()
  }

  return (
    <Modal
      header={t('userMenu.language.label')}
      dialogProps={{
        open,
        onClose: () => onClose(),
      }}
      onDismiss={onClose}
    >
      <MenuList disablePadding>
        <UserMenuRadioItem
          checked={currentLanguage === 'nl'}
          primary={
            <LanguageMenuLabel
              countryCode='nl'
              label={t('userMenu.language.dutch')}
            />
          }
          onClick={() => {
            void handleLanguageChange('nl')
          }}
        />

        <UserMenuRadioItem
          checked={currentLanguage === 'en'}
          primary={
            <LanguageMenuLabel
              countryCode='gb'
              label={t('userMenu.language.english')}
            />
          }
          onClick={() => {
            void handleLanguageChange('en')
          }}
        />
      </MenuList>
    </Modal>
  )
}
